export default __webpack_public_path__ + "static/media/Rolec_Logo.72cc3bf0.svg";